/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { Info } from '@one-thd/sui-icons';
import { Link } from '@one-thd/sui-atomic-components';
import { getPaymentEstimatorDetails, getPaymentEstimatorValues, loadEstimatorScript } from '../utils/payment-estimator-utils';
import ProXtraDrawer from '../common/pro-xtra-drawer.component';
import { formatNumber, } from '../utils/general';
import TermsAndConditionsDrawerPlccPrompt
  from '../common/terms-and-condition-drawer-plcc-prompt.component';

export function PLCCPromptPaymentEstimator(props) {
  const {
    plccEligibleAmount,
    saleAmount,
    isB2B
  } = props;

  const experienceContext = useContext(ExperienceContext);
  const paymentEstimatorVersion = useConfigService('PaymentEstimatorVersion') || 'v1.5.0';
  const [paymentEstimatorDetails, setPaymentEstimatorDetails] = useState(null);
  const [paymentEstimatorValues, setPaymentEstimatorValues] = useState(null);
  const [paymentEstimatorLoaded, setPaymentEstimatorLoaded] = useState(false);
  const { channel } = experienceContext;
  const isMobile = channel === 'mobile';
  const { tooltipText, displayPrice, promotionTerm } = paymentEstimatorDetails || {};
  const { suggestedAmount } = paymentEstimatorValues || {};
  const [displayDrawer, setDisplayDrawer] = useState(false);
  const isAppliancePromo = tooltipText?.includes('Appliance');
  const isTieredPromo = tooltipText?.includes('24 Months');
  const isTieredAppliancePromo = tooltipText?.includes('18 Months on Appliance');

  useEffect(() => {
    const loadPaymentEstimator = () => {
      setPaymentEstimatorDetails(
        getPaymentEstimatorDetails(saleAmount, isMobile, isAppliancePromo, isTieredPromo, 'opc')
      );
      setPaymentEstimatorValues(getPaymentEstimatorValues(saleAmount, isAppliancePromo, isTieredPromo));
      setPaymentEstimatorLoaded(true);
    };

    if (!isB2B) {
      loadEstimatorScript(
        paymentEstimatorVersion,
        loadPaymentEstimator,
        isMobile
      );
    }
  }, [saleAmount]);

  const DisplayIcon = () => (
    <span className="sui-pl-1 sui-cursor-pointer sui-relative sui-top-1">
      <Info color="info" data-testid="info-link" size="small" onClick={() => setDisplayDrawer(true)} />
    </span>
  );

  const DisplayLearnMoreIcon = () => (
    <span className="sui-align-text-bottom">
      {' '}
      <Link
        component="button"
        color="brand"
        data-testid="info-link"
        onClick={() => setDisplayDrawer(true)}
      >
        Learn More
      </Link>
    </span>
  );

  const renderMessage = () => {

    if (isB2B) {
      return (
        <>
          Earn <b>${formatNumber(Number(plccEligibleAmount) * 4)} in Perks Spend</b> on a $
          {formatNumber(plccEligibleAmount)} qualifying purchase when you join Pro Xtra, register and use your card.
          <DisplayLearnMoreIcon />
        </>
      );
    }

    if (displayPrice) {
      return (
        <>
          <b>Pay ${formatNumber(suggestedAmount)} per month** suggested payments with {promotionTerm} months** financing</b> on this ${formatNumber(saleAmount)}{' '}
          purchase.
          <DisplayIcon />
        </>
      );
    }

    return <b>The Home Depot Credit Card is like an extension cord for your wallet</b>;
  };

  return (
    <React.Fragment data-testid="payment-option">
      <div data-testid="payment-option">
        {isB2B ? (
          <ProXtraDrawer closeDrawer={() => setDisplayDrawer(false)} open={displayDrawer} hideApplynow applyNowUrl={' '} />
        ) : (
          <TermsAndConditionsDrawerPlccPrompt
            closeDrawer={() => setDisplayDrawer(false)}
            open={displayDrawer}
            isAppliancePromo={isAppliancePromo}
            isTieredPromo={isTieredPromo}
            isTieredAppliancePromo={isTieredAppliancePromo}
            isB2B={isB2B}
            paymentEstimatorLoaded={paymentEstimatorLoaded}
            saleAmount={saleAmount}
            isAppliance={isAppliancePromo}
            isTiered={isTieredPromo}
          />
        )}
        <div className="sui-text-base sui-ml-2">
          {renderMessage()}
        </div>
      </div>
    </React.Fragment>
  );
}

PLCCPromptPaymentEstimator.propTypes = {
  plccEligibleAmount: PropTypes.number,
  saleAmount: PropTypes.number,
  isB2B: PropTypes.bool,
};

PLCCPromptPaymentEstimator.defaultProps = {
  plccEligibleAmount: 0,
  saleAmount: 0,
  isB2B: false,
};
